import { Component, OnInit } from '@angular/core';
import { DwRadioItem } from '../quiz-answer-true-false/quiz-answer-true-false.component';
import { QuizAnswerBaseComponent } from '../base/quiz-answer-base.component';
import { QuestionAnswerEntity } from '../../../../../meta-data/app-meta-data.service';
import { ArrayUtilService } from '../../../../shared/util/array-util.service';
import { QuestionAnswerReviews } from '../../../models/question-answer-review.model';
import { QuizUtilService } from '../../../services/quiz-util.service';

@Component({
  selector: 'app-quiz-answer-multiple-choice',
  template: `
  <label *ngFor="let answer of answersToShow; let i = index" class="quiz-option"
         [class.is-selected]="!reviewAnswers && questionAnswerValue.quizQuestionAnswerId === answer.QuestionAnswerId"
         [class.is-correct]="(reviewAnswers || testMode) && answerReviews[i]?.textNote !== 'Incorrect' && !!answerReviews[i]"
         [class.is-incorrect]="(reviewAnswers || testMode) && answerReviews[i]?.textNote === 'Incorrect'"
         [class.is-disabled]="reviewAnswers">
    <input type="radio" class="quiz-option__input" name="answer"
           [disabled]="reviewAnswers"
           [(ngModel)]="questionAnswerValue.quizQuestionAnswerId"
           [value]="answer.QuestionAnswerId"
           (ngModelChange)="setAnswer($event, answer)" />
    <span class="quiz-option__chip" aria-hidden="true">{{letterFor(i)}}</span>
    <span class="quiz-option__text">
      {{answer.AnswerText}}
      <dw-html-view *ngIf="(reviewAnswers || testMode) && answerReviews[i]?.explanationText"
                    class="quiz-option__explanation"
                    [ngModel]="answerReviews[i].explanationText"></dw-html-view>
    </span>

    <span *ngIf="answerReviews[i] && (testMode || reviewAnswers)" class="quiz-option__review">
      <i class="quiz-option__review-icon" [ngClass]="answerReviews[i].iconClass" aria-hidden="true"></i>
      <span class="quiz-option__review-note">{{answerReviews[i].textNote}}</span>
      <button type="button" class="quiz-option__sparkle" *ngIf="answerReviews[i].aiExplanationHtml"
              (click)="setAiDetail(answerReviews[i].aiExplanationHtml); $event.preventDefault(); $event.stopPropagation();"
              title="AI Explanation">
        <i class="fa fa-sparkles" aria-hidden="true"></i>
        <span>Explain</span>
      </button>
    </span>
  </label>

  <div *ngIf="currentAiExplanationHtml" class="answer-explanation-ai">
    <span class="answer-explanation-ai-header"><i class="fa fa-sparkles dw-purple" aria-hidden="true"></i> Explanation:</span>
    <dw-html-view [ngModel]="currentAiExplanationHtml"></dw-html-view>
  </div>
  `
})
export class QuizAnswerMultipleChoiceComponent extends QuizAnswerBaseComponent {
  answersToShow: QuestionAnswerEntity[] = [];
  answerReviews: QuestionAnswerReviews = {};

  currentAiExplanationHtml: string = ''; 

  constructor(private arrayUtilService: ArrayUtilService, private quizUtilService: QuizUtilService) {
    super();
  }

  setAnswer(value, answer: QuestionAnswerEntity) {

    this.questionAnswerValue.quizQuestionAnswerId = answer.QuestionAnswerId;

    this.setAnswerValue(this.questionAnswerValue, this.questionAnswerValue.quizQuestionAnswerId > 0);

    if (this.testMode) {
      this.answerReviews = this.quizUtilService.getAnswerReviews(this.questionLink, this.questionResult, this.questionAnswerValue, this.answersToShow, this.testMode);
    }

    this.setupAiExplanation();
  }

  setAiDetail(aiExplanationHtml: string) {
    this.currentAiExplanationHtml = aiExplanationHtml;
  }

  setupAnswer(): void {
    this.answerReviews = {};
    this.currentAiExplanationHtml = '';

    // Set answers to use default order
    this.answersToShow = [...this.question.QuestionAnswer];

    if (this.questionAnswerValue.answerOrder) {
      this.answersToShow = this.answersToShow.sort((a, b) => {
        return this.questionAnswerValue.answerOrder.indexOf(a.QuestionAnswerId) - this.questionAnswerValue.answerOrder.indexOf(b.QuestionAnswerId);
      });

      if (this.reviewAnswers || this.testMode) {
        this.answerReviews = this.quizUtilService.getAnswerReviews(
          this.questionLink,
          this.questionResult,
          this.questionAnswerValue,
          this.answersToShow,
          this.testMode);

        this.setupAiExplanation();
      }
      return;
    }

    // Setup new order
    if (this.question.UseRandomOrder) {
      this.answersToShow = this.arrayUtilService.shuffle(this.answersToShow);
    }

    // Set the answer order so when we view it later, it will be in the same order
    this.questionAnswerValue.answerOrder = this.answersToShow.map((answer) => answer.QuestionAnswerId);
    this.persistAnswerValue(this.questionAnswerValue);

    if (this.reviewAnswers || this.testMode) {
      this.answerReviews = this.quizUtilService.getAnswerReviews(
        this.questionLink,
        this.questionResult,
        this.questionAnswerValue,
        this.answersToShow,
        this.testMode);
      this.setupAiExplanation();
    }
  }

  private setupAiExplanation() {
    this.currentAiExplanationHtml = '';
    if (!this.answerReviews) {
      return;
    }

    const answer = this.answersToShow.find(a => a.QuestionAnswerId === this.questionAnswerValue.quizQuestionAnswerId);
    const index = this.answersToShow.indexOf(answer);
    const answerReview = this.answerReviews[index];

    this.currentAiExplanationHtml = answerReview?.aiExplanationHtml || '';
  }

}
